export class UrlHelper {
    /**
     * The URL requested, before initial routing.
     */
    static readonly initialUrl = location.href;

    static getQueryParameters(): any {
        return UrlHelper.getQueryParametersUsingParameters(document.location.search);
    }

    static getQueryParametersUsingParameters(search: string): any {
        return search.replace(/(^\?)/, '').split('&').map(function (n) { return n = n.split('='), this[n[0]] = n[1], this; }.bind({}))[0];
    }

    static getInitialUrlParameters(): any {
        let questionMarkIndex = UrlHelper.initialUrl.indexOf('?');
        if (questionMarkIndex >= 0) {
            return UrlHelper.initialUrl.substr(questionMarkIndex, UrlHelper.initialUrl.length - questionMarkIndex);
        }

        return '';
    }

    static getReturnUrl(): string {
        const queryStringObj = UrlHelper.getQueryParametersUsingParameters(UrlHelper.getInitialUrlParameters());
        if (queryStringObj.returnUrl) {
            return decodeURIComponent(queryStringObj.returnUrl);
        }

        return null;
    }

    static getSingleSignIn(): boolean {
        const queryStringObj = UrlHelper.getQueryParametersUsingParameters(UrlHelper.getInitialUrlParameters());
        if (queryStringObj.ss) {
            return queryStringObj.ss;
        }

        return false;
    }

    static isTokenUrl(url):boolean {
        return url && url.indexOf("?token=") >= 0;
    }

    static isInstallUrl(url):boolean {
        return url && url.indexOf("app/admin/install") >= 0;
    }

    static isRegistrationUrl(url):boolean {
        return url && (url.indexOf("app/event/registration") >= 0 || url.indexOf("app/event/signUp") >= 0) || url.indexOf("app/congresso/home") >= 0 ;
    }

    static isScheduleUrl(url):boolean {
        return url && url.indexOf("app/event/schedule") >= 0;
    }

    static isCertificateValidateUrl(url):boolean {
        return url && url.indexOf("app/event/validateCertificate") >= 0;
    }

    static isAnnuityPayment(url):boolean {
        return url && url.indexOf("app/annuity/payment") >= 0;
    }

    static isCart(url):boolean {
        return url && (url.indexOf("app/store/cart") >= 0 || url.indexOf("app/store/checkout") >= 0);
    }
}



// WEBPACK FOOTER //
// ./src/shared/helpers/UrlHelper.ts